<template>
  <div class="card card-custom gutter-b">
    <!-- Header -->
    <div class="card-header border-0 py-5">
      <div class="card-title">
        <h3 class="card-label font-weight-bolder text-dark">
          Quản lý cơ chế lương
        </h3>
      </div>

      <div class="card-toolbar">
        <button
            type="button"
            class="btn btn-success font-weight-bold d-inline-flex align-items-center"
            @click="handleCreate"
        >
          <i class="el-icon-plus mr-1"></i>
          Thêm mới
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="card-body pt-0 pb-5">
      <el-table
          :data="salaryMechanisms"
          v-loading="loading"
          element-loading-text="Đang tải dữ liệu..."
          border
          stripe
          class="w-100"
          :header-cell-style="{ background: '#F3F6F9', color: '#3F4254', fontWeight: '700' }"
          empty-text="Chưa có dữ liệu"
      >
        <el-table-column
            type="index"
            label="STT"
            width="60"
            align="center"
        />

        <el-table-column
            prop="name"
            label="Tên cơ chế lương"
            min-width="220"
        >
          <template #default="{ row }">
            <span class="text-dark">{{ row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="area_type_name"
            label="Loại khu vực"
            min-width="140"
            align="center"
        >
          <template #default="{ row }">
            <span v-if="row.area_type_name" class="label label-lg label-inline label-light-primary font-weight-bold">
              {{ row.area_type_name }}
            </span>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="created_name"
            label="Người tạo"
            min-width="150"
        >
          <template #default="{ row }">
            <span class="text-dark-75 font-weight-bold">{{ row.created_name || '—' }}</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="created_at"
            label="Ngày tạo"
            min-width="150"
            align="center"
        >
          <template #default="{ row }">
            <span>{{ row.created_at || '—' }}</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="updated_at"
            label="Ngày chỉnh sửa"
            min-width="150"
            align="center"
        >
          <template #default="{ row }">
            <span>{{ row.updated_at || '—' }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Hành động"
            width="100"
            align="center"
        >
          <template #default="{ row }">
            <el-tooltip content="Chỉnh sửa" placement="top">
              <button
                  type="button"
                  class="btn btn-icon btn-light-primary btn-hover-primary btn-sm mr-2"
                  @click="handleEdit(row)"
              >
                <i class="el-icon-edit font-size-h6"></i>
              </button>
            </el-tooltip>

            <el-tooltip content="Xóa" placement="top">
              <button
                  type="button"
                  class="btn btn-icon btn-light-danger btn-hover-danger btn-sm"
                  @click="handleDelete(row)"
              >
                <i class="el-icon-delete font-size-h6"></i>
              </button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
          :title="isEdit ? 'Chỉnh sửa cơ chế lương' : 'Thêm mới cơ chế lương'"
          :visible.sync="dialogVisible"
          width="50%"
          top="8vh"
          :close-on-click-modal="false"
          append-to-body
      >
        <dialog-create-or-edit-salary-mechanism
            :salary-mechanism="selectedSalaryMechanism"
            :areas="areas"
            :branches="branches"
            :candidateTypes="candidateTypes"
            :loading="saving"
            @save="handleSaveSalaryMechanism"
            @cancel="dialogVisible = false"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import DialogCreateOrEditSalaryMechanism from "./components/DialogCreateOrEditSalaryMechanism.vue";
import {GET_AREAS} from "../../../core/services/store/center/area.module";
import {GET_BRANCHES} from "../../../core/services/store/center/branch.module";
import {CREATE_SALARY_MECHANISM, GET_SALARY_MECHANISMS, EDIT_SALARY_MECHANISM, GET_CANDIDATE_TYPE, DELETE_SALARY_MECHANISM} from "../../../core/services/store/salary-mechanism/salaryMechanism.module";


export default {
  name: "salary-mechanism",

  components: {
    DialogCreateOrEditSalaryMechanism
  },

  data() {
    return {
      loading: false,
      saving: false,

      dialogVisible: false,
      selectedSalaryMechanism: null,
      areas: [],
      branches: [],
      salaryMechanisms: [],
      candidateTypes: [],
    };
  },

  computed: {
    isEdit() {
      return !!this.selectedSalaryMechanism?.id;
    }
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: "Quản lý cơ chế lương"}]);
    this.getSalaryMechanisms();
    this.getAreas();
    this.getBranches();
    this.getCandidateType();
  },

  methods: {
    getSalaryMechanisms() {
      this.$store.dispatch(GET_SALARY_MECHANISMS, {}).then((data) => {
        if (!data.error) {
          this.salaryMechanisms = data.data ?? [];
        }
      })
    },
    getBranches() {
      this.$store.dispatch(GET_BRANCHES, {
        status: 1,
        limit: 100000,
      }).then((data) => {
        if (!data.error) {
          this.branches = data.data.data;
        }
      })
    },

    getAreas() {
      this.$store.dispatch(GET_AREAS, {
        limit: 10000,
        status: 1
      }).then((res) => {
        if (!res.error) {
          this.areas = res.data.data;
        }
      }).catch((e) => {
        console.log(e, 'error')
      });
    },
    handleCreate() {
      this.selectedSalaryMechanism = null;
      this.dialogVisible = true;
    },

    handleEdit(item) {
      this.selectedSalaryMechanism = JSON.parse(JSON.stringify(item));
      this.dialogVisible = true;
    },

    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xóa cơ chế lương "${item.name}"?`, "Xác nhận", {
        confirmButtonText: "Xóa",
        cancelButtonText: "Hủy",
        type: "warning"
      }).then(() => {
        this.$store.dispatch(DELETE_SALARY_MECHANISM, {
          id: item.id,
        }).then((res) => {
          if (!res.error) {
            this.notification(res.message || "Xóa cơ chế lương thành công", 'success');
            this.getSalaryMechanisms();
          } else {
            this.notification(res.message || "Xóa cơ chế lương thất bại", 'error');
          }
        }).catch((e) => {
          const message = e?.response?.data?.message || e.message || "Xóa cơ chế lương thất bại";
          this.notification(message, 'error');
        });
      }).catch(() => {});
    },

    async handleSaveSalaryMechanism(payload) {
      this.saving = true;

      try {
        if (payload.id) {
          const changes = this.getChangedFields(
              this.selectedSalaryMechanism,
              payload
          );

          if (!Object.keys(changes).length) {
            this.$message.info("Không có thay đổi");
            return;
          }

          await this.editSalaryMechanism({
            id: payload.id,
            ...changes
          });
        } else {
          await this.createSalaryMechanism(payload);
        }

        this.dialogVisible = false;

        await this.getSalaryMechanisms();
      } catch (e) {
        console.error(e);
      } finally {
        this.saving = false;
      }
    },

    createSalaryMechanism(payload) {
      return this.$store.dispatch(CREATE_SALARY_MECHANISM, payload).then((res) => {
        if (!res.error) {
          this.notification(res.message || "Thêm cơ chế lương thành công", 'success');
        } else {
          this.notification(res.message || "Thêm cơ chế lương thất bại", 'error');
        }
      }).catch((e) => {
        const message = e?.response?.data?.message || e.message || "Thêm cơ chế lương thất bại";
        this.notification(message, 'error');
      });
    },

    editSalaryMechanism(payload) {
      return this.$store.dispatch(EDIT_SALARY_MECHANISM, payload).then((res) => {
        if (!res.error) {
          this.notification(res.message || "Cập nhập cơ chế lương thành công", 'success');
        } else {
          this.notification(res.message || "Cập nhập cơ chế lương thất bại", 'error');
        }
      }).catch((e) => {
        const message = e?.response?.data?.message || e.message || "Cập nhập cơ chế lương thất bại";
        this.notification(message, 'error');
      });
    },

    getChangedFields(original, current) {
      const fields = [
        'name',
        'area_type_ids',
        'area_ids',
        'candidate_type_ids',
        'branch_ids'
      ];

      return fields.reduce((result, field) => {
        const oldValue = original?.[field];
        const newValue = current?.[field];

        if (!this.isSameValue(oldValue, newValue)) {
          result[field] = newValue;
        }

        return result;
      }, {});
    },

    isSameValue(oldValue, newValue) {
      if (Array.isArray(oldValue) || Array.isArray(newValue)) {
        const oldIds = [...(oldValue || [])].map(Number).sort((a, b) => a - b);
        const newIds = [...(newValue || [])].map(Number).sort((a, b) => a - b);

        return JSON.stringify(oldIds) === JSON.stringify(newIds);
      }

      return oldValue === newValue;
    },

    notification(message, type) {
      this.$notify({
        title: type === 'success' ? 'Thành công' : 'Thất bại',
        message: message,
        type: type
      });
    },

    getCandidateType() {
      return this.$store.dispatch(GET_CANDIDATE_TYPE).then((res) => {
        if (!res.error) {
          this.candidateTypes = res.data;
          console.log('this.candidateTypes',res, this.candidateTypes)
        }
      }).catch((e) => {
        console.error(e);
      });
    }
  }
};
</script>